import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';

export interface DynamicField {
  key: string;
  type:
    | 'horizontalArtistChoice'
    | 'horizontalMultiCheckbox'
    | 'horizontalInput'
    | 'horizontalSelect'
    | 'horizontalBooleanField'
    | 'horizontalRadio';
  templateOptions: {
    label?: string;
    options?: Array<any> | Record<string, any>;
  };
}

@Component({
    selector: 'app-dynamic-fields',
    templateUrl: './dynamic-fields.component.html',
    styleUrls: ['./dynamic-fields.component.scss'],
    standalone: false
})
export class DynamicFieldsComponent {
  @Input() form!: FormGroup;
  @Input() field!: DynamicField;
  @Input() deployUrl = '';
  @Input() selectOptionsMap: Record<string, any[]> = {};
  @Input() placeholderMap: Record<string, string> = {};
  @Input() preselectedArtists: any[] = [];
  @Output() multiSelectChanged = new EventEmitter<{key: string; value: any}>();
  @Output() multiSelectRemoved = new EventEmitter<{key: string; value: any}>();
  @Output() usersSelected = new EventEmitter<any>();

  get control() {
    return this.form.get(this.field.key);
  }

  get serverError(): string | null {
    return (this.control?.errors as any)?.serverError ?? null;
  }
}
